import Vue from 'vue';
import exchangeRate from './exchange-rate/exchange-rate.vue';
import exchangeRateDownload from './exchange-rate-download/exchange-rate-download.vue';
import store from '../common/js/vuex/store';
import exchangeRateStore from '../applications/exchange-rate/exchange-rate-vuex';
if (!store.hasModule(['exchangeRate'])) {
	store.registerModule('exchangeRate', exchangeRateStore);
}
Vue.component('exchange-rate', exchangeRate);
Vue.component('exchange-rate-download', exchangeRateDownload);
